import React from "react";
import bots from "../botsData";

const Privacy = () => {
  const botNames = bots.map((bot) => bot.name).join(", ");

  return (
    <div className="relative min-h-screen py-16 px-4">
      <div className="pointer-events-none absolute inset-x-0 top-6 left-1/2 h-px w-[80%] -translate-x-1/2 bg-gradient-to-r from-transparent via-apb-accent-cyan to-transparent opacity-70" />
      <div className="pointer-events-none absolute inset-x-0 top-20 left-0 h-full w-full">
        <div className="mx-auto h-full max-w-6xl bg-[linear-gradient(to_right,transparent_0%,rgba(255,255,255,0.06)_2px,transparent_2px,transparent_52px),linear-gradient(to_bottom,transparent_0%,rgba(255,255,255,0.06)_2px,transparent_2px,transparent_52px)] bg-[length:52px_52px,52px_52px] opacity-10" />
      </div>
      <main className="flex-grow relative z-10">
        <article className="max-w-5xl mx-auto apb-surface-glass p-8 sm:p-10 rounded-2xl mb-16 mt-2 border border-apb-border-soft">
          <div className="inline-flex items-center gap-2 rounded-full border border-apb-border-soft bg-black/20 px-4 py-1.5 text-xs uppercase tracking-[0.25em] text-apb-text-secondary">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-apb-accent-cyan apb-glow-cyan" />
            Privacy
          </div>
          <h1 className="text-4xl font-extrabold mt-5 mb-2 apb-glow-text">Privacy Policy for Afterparty Bots</h1>
          <p className="text-apb-text-secondary mb-6">Last Updated: January 20, 2026</p>

          <p className="text-lg text-apb-text-secondary mb-5">
            Afterparty Bots ("we," "our," "us") are committed to protecting the privacy of our users. This Privacy Policy outlines what information we collect, how we use it, and your rights regarding your data when using our bots: {botNames}.
          </p>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">1. Information We Collect</h2>
            <ul className="list-disc list-inside mt-3 space-y-2 text-apb-text-secondary">
            <li>Usernames, user IDs, and profile data available through Discord.</li>
            <li>Server-specific data, such as server IDs, channel IDs, and role IDs.</li>
            <li>Message content (only temporarily for command processing).</li>
            <li>Interaction data (such as issued commands and feature usage).</li>
            </ul>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">2. How We Use Your Information</h2>
            <ul className="list-disc list-inside mt-3 space-y-2 text-apb-text-secondary">
            <li>Enable and enhance the Bots' features, such as music playback, moderation, verification, and role management.</li>
            <li>Provide personalized experiences and respond to user interactions.</li>
            <li>Improve the Bots' performance and troubleshoot issues.</li>
            <li>Ensure compliance with Discord's Terms of Service and Community Guidelines.</li>
            </ul>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">3. Data Sharing</h2>
            <p className="text-apb-text-secondary mt-3">
            We do not sell, rent, or share your personal data with third parties. Data may only be disclosed in the following circumstances:
          </p>
            <ul className="list-disc list-inside mt-3 space-y-2 text-apb-text-secondary">
            <li>To comply with legal obligations or enforceable governmental requests.</li>
            <li>With explicit user consent.</li>
            </ul>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">4. Contact Us</h2>
            <p className="text-apb-text-secondary mt-3">
              For questions, concerns, or complaints about this Privacy Policy, contact us at{" "}
              <a href="mailto:support@afterpartylabs.xyz" className="text-apb-accent-cyan hover:text-white underline underline-offset-4">
                support@afterpartylabs.xyz
              </a>.
            </p>
          </section>
        </article>
      </main>
    </div>
  );
};

export default Privacy;
